function Footer () {
    return(
        <div class="bg-cyan-100 pt-10 pb-4">
            <h3 class="text-lg">❤ I love feeding my hungry guys... ❤</h3>
        </div>
    )
}

export default Footer;